function mapLineBreak(text) {
  return (text || '').replace(/\n/g, '<br/>');
}

function formatDate(timestamp) {
  try {
    return new Date(timestamp).toISOString().split('T')[0];
  } catch (ex) {
    return null;
  }
}
function formatDateTime(timestamp) {
  let weekList = {
    0: 'Mon.',
    1: 'Tue.',
    2: 'Wed.',
    3: 'Thu.',
    4: 'Fri.',
    5: 'Sat.',
    6: 'Sun.',
  };
  try {
    let date = new Date(timestamp).toISOString().split('T')[0];
    let week = weekList[new Date(timestamp).getDay()];
    let time = new Date(timestamp).toISOString().split('T')[1].split('.')[0];
    return `${date} ${week} ${time}`;
  } catch (ex) {
    return null;
  }
}
function formatCurrencyDisplay(number) {
  try {
    return number.toLocaleString('en-US', 'currency');
  } catch (er) {
    return '-- --';
  }
}

module.exports = {
  mapLineBreak,
  formatDate,
  formatDateTime,
  formatCurrencyDisplay,
};
